interface HeadProps {
  title: string,
  description?: string,
  noSuffix?: boolean,
  noIndex?: boolean,
}

export default function Head({ title, noSuffix, noIndex, description}: HeadProps) {
  const formattedTitle = noSuffix ? title : `${title} | Fantasy Town Generator`;
  return (
    <>
      <title>{formattedTitle}</title>
      <meta name="title" content={formattedTitle} />
      <meta name="description" content={description} />
      { noIndex && <meta name="robots" content="noindex" /> }
    </>
  );
}
